import React from 'react';
import CKEditor from "react-ckeditor-component";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { this.props.history } from 'react-router';
import * as SVGICONS from '../../../images/img/images';
import * as AdminIndexActions from '../../../actions/admin/Index/adminIndexAction';
// import validator from './../../common/validator.js';
import autoBind from 'auto-bind';
import * as constant from '../../../constants/constant';

class EmailTemplate extends React.Component {
	constructor(props, context) {
		// CKEditor.replace('editor1', {
		// 	extraPlugins: 'imageuploader'
		// });
		super(props, context);
		autoBind(this);
		this.state = {
			oldFile: '',
			imagePreviewUrl: '',
			emailTemplateTitle: '',
			description: '',
			descriptionMessage: '',
			emailTemplateTitleMessage: '',
			emailTemplateData: []
		}
		this.addEmailTemplate = this.addEmailTemplate.bind(this);
		this.onChangeEmailTemplate = this.onChangeEmailTemplate.bind(this);
		this.onChange = this.onChange.bind(this);
	}

	onChange(evt) {
		var newContent = evt.editor.getData();
        console.log("*******************", evt)
		this.setState({
			description: newContent,
		})
		if (newContent != '') {
			this.setState({
				descriptionMessage: ''
			})
			// this.setState({
			// })
		} else {
			this.setState({
				descriptionMessage: 'Email Template Description is required'
			})
		}
	}
	updateContent(newContent) {
		this.setState({
			content: newContent
		})
	}
	componentWillMount() {
		if (this.props.match.params.templateId) {
			let emailTemplateId = { templateId: this.props.match.params.templateId };
			this.props.actions.getEmailTemplateById(emailTemplateId);
		} else {
			// this.setState({
			// 	emailTemplateTitle: '',
			// 	description: ''
			// })
		}
	}
	componentWillReceiveProps(nextProps) {
		console.log("===>peeeee", nextProps)
		if (nextProps.emailTemplateData && nextProps.emailTemplateData.success && this.props.match.params.templateId) {
			console.log("=>>TRUEW")
			this.setState({
				description: nextProps.emailTemplateData.description ? nextProps.emailTemplateData.description : this.state.description.value,
				content: nextProps.emailTemplateData.description ? nextProps.emailTemplateData.description : '',
				emailTemplateTitle: nextProps.emailTemplateData.subject ? nextProps.emailTemplateData.subject : this.state.documentTypeId.value
			})
		}
		else {
			console.log("=>>FALSE")
			this.setState({
				spinner: false,
				emailTemplateTitle: '',
				description: '',
				content: ''
			})
			// document.getElementById('emailTemplateTitle').value = ''
			// document.getElementById('browsepic').value = ''
		}
	}
	componentDidMount() {

	}
	reSetEmailTemplateForm() {
        console.log("*******TEMPLETERESSET******************", this.state)
		var state = this.state
		this.setState({
			emailTemplateTitle: '',
			description: ''
		})
		// document.getElementById('emailTemplateTitle').value = ''
		// document.getElementById('description').value = ''
		// document.getElementById('browsepic').value = ''
	}

	addEmailTemplate(event) {
		event.preventDefault();
		var state = this.state;
		if (this.state.emailTemplateTitle == '') {
			this.setState({ emailTemplateTitleMessage: 'Email Template Subject is required' });
		}
		if (this.state.description == '') {
			this.setState({ descriptionMessage: 'Email Template Description is required' });
		}
		console.log("===>", this.state)
		if (this.state.emailTemplateTitle != '' && this.state.description != '' && (this.state.emailTemplateTitleMessage == '' || this.state.emailTemplateTitleMessage == undefined) && (this.state.descriptionMessage == '' || this.state.descriptionMessage == undefined)) {
			let newContent = this.state.content;
			let l = newContent.slice(0, newContent.indexOf('table')-1);
			let desc = this.state.description
			let d = desc.slice(0, desc.indexOf(' '));
			
			let healthTipsObj = {
				emailTemplateTitle: this.state.emailTemplateTitle,
				description: l+this.state.description+`</body>`,
			}
			if (this.props.match.params.templateId)
			healthTipsObj.templateId = this.props.match.params.templateId
			console.log("===>HELATHLT", healthTipsObj)
				return
			this.props.actions.addEmailTemplate(healthTipsObj, this.props);

		}
	}

	onCancel() {
		this.props.history.push('/user/email-templates');
	}

	onChangeEmailTemplate(event) {
		this.setState({
			emailTemplateTitle: event.target.value
		})
		if (event.target.value != '') {
			this.setState({
				emailTemplateTitleMessage: ''
			})
		} else {
			this.setState({
				emailTemplateTitleMessage: 'Email Template Subject is required'
			})
		}
	}

	resetValidationStates() {

	}
	render() {
		let imagePreviewUrl
		if (this.state.oldFile && this.state.imagePreviewUrl == '') {
			let folderName = constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + folderName + this.state.oldFile;
		} else {
			imagePreviewUrl = this.state.imagePreviewUrl;
		}
		console.log('this.state:', this.state)
		return (
			<div className="content-wrapper">
				<section className="content container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li>
											<Link href="#tab_1" data-toggle="tab" className="active show">Email Template</Link>
										</li>
									</ul>
									<form className="login-form" id="documentUploadForm" name="form" onSubmit={this.addEmailTemplate.bind(this)}>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother">
													<div className="emailTemplateinput">
														<div className="row">
															<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																<div className="boxMrgB">
																	<div className="row">
																		<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																			<div className="input-group inputBg email">
																				<span className="input-group-addon m-t-0">
																					<SVGICONS.BlogName />
																				</span>
																				<input type="text" className="form-control p-d-20" placeholder="Email Template Subject" id="emailTemplateTitle" name="emailTemplateTitle" onChange={this.onChangeEmailTemplate.bind(this)} value={this.state.emailTemplateTitle} />
																			</div>
																			<span className="help-block" style={{ fontSize: 11 }}>{this.state.emailTemplateTitleMessage}</span>
																		</div>
																		<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																			<div className="m-t-30">
																				{this.props.match.params.templateId && this.state.content ?
																					<CKEditor
																						activeClass="p10"
																						content={this.state.description}
																						events={{
																							"blur": this.onBlur,
																							// "afterPaste": this.afterPaste,
																							"change": this.onChange
																						}}
																					/> : ''}
																				{!this.props.match.params.templateId ?
																					<CKEditor
																						activeClass="p10"
																						content={this.state.content}
																						events={{

																							"change": this.onChange
																						}}
																					/> : ''}
																			</div>
																			<span className="help-block" style={{ fontSize: 11 }}>{this.state.descriptionMessage}</span>
																		</div>
																	</div>
																</div>
																<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																	<div className="m-t-20 text-center">
																		<div className="toppad">
																			<button type="submit" className="btn btn-warning btn-lg pd-btn" >Submit</button> {!this.props.match.params.templateId ? <button type="button" onClick={this.reSetEmailTemplateForm} className="btn btn-cancel btn-default btn-lg p-d-rst">Reset</button> : ''}{this.props.match.params.templateId ? <button type="button" onClick={this.onCancel} className="btn btn-cancel btn-default btn-lg p-d-rst">Cancel</button> : ''}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div >
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		emailTemplateData: state.adminUser.emailTemplates
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(EmailTemplate);